<template>
  <div v-loading="loading">
    <el-tabs type="card" @tab-click="tabDashboard">
      <el-tab-pane label="Statistik">
        <el-date-picker v-model="month" type="month" size="normal" placeholder="Pilih Bulan" format="MMMM yyyy" @change="getClicks" value-format="yyyy-MM-dd">
        </el-date-picker>
        <h2 style="text-align: left;" v-if="month">Statistik klik bagi bulan {{ month | bulan }} </h2>
        <span style="font-size: 12px;">Copy dan share link affiliate anda</span>
        <el-input ref="cliplink" :value="'https://publicgold.me/?aff=' + clicks.pgcode" size="mini" readonly style="width: 300px" v-on:focus="$event.target.select()">
          <template slot="append"><el-button type="info" size="mini" @click="cliplink"><font-awesome-icon :icon="['fa', 'clipboard']"></font-awesome-icon></el-button>
          </template>
        </el-input>
        
        <el-row :gutter="20" style="margin-top: 50px;">
          <el-col :span="12" :offset="0">
            <el-card shadow="hover" :body-style="{ padding: '20px' }">
              <div slot="header">
                <span>Jumlah Klik Web</span>
              </div>
              <span style="font-size: 50px; color: #0db1ba;">{{ clicks.web }}</span>
            </el-card>
            
          </el-col>
          <el-col :span="12" :offset="0">
            <el-card shadow="hover" :body-style="{ padding: '20px' }">
              <div slot="header">
                <span>Jumlah Klik Affiliate</span>
              </div>
              <span style="font-size: 50px; color: #0db1ba;">{{ clicks.aff }}</span>
            </el-card>
          </el-col>
        </el-row>
        
        <el-table :data="clicks.referral" border stripe style="margin-top: 50px;">
          <el-table-column align="center" type="index" label="#" width="50"></el-table-column>
          <el-table-column prop="fullname" label="Nama Referral" width="500"></el-table-column>
          <el-table-column prop="webid" label="Web ID" width="200"></el-table-column>
          <el-table-column align="center" prop="pgcode" label="PG Code" width="130"></el-table-column>
          <el-table-column align="center" prop="tarikh_wujud" label="Tarikh Wujud" width="110">
              <template slot-scope="x">
                  {{ x.row.tarikh_wujud | tarikh }}
              </template>
          </el-table-column>
          <el-table-column align="center" prop="tarikh_tamat" label="Tarikh Tamat" width="110">
              <template slot-scope="x">
                  {{ x.row.tarikh_tamat | tarikh }}
              </template>
          </el-table-column>
          <el-table-column align="center" prop="active" label="Aktif ?" width="110">
            <template slot-scope="x">
              {{ Number(x.row.active) ? 'Aktif' : 'Tidak Aktif' }}
            </template>
          </el-table-column>
        </el-table>
        
        <el-table :data="commissions"  stripe ref="tblSenarai" empty-text="Loading data.." style=" padding-top: 50px;">
                
              <el-table-column label="#" type="index" width="100"></el-table-column>
              <el-table-column prop="client" label="Client" width="400"></el-table-column>
              <el-table-column prop="package" label="Package" width="120"></el-table-column>
              <el-table-column prop="type" label="Type" width="130"></el-table-column>
              <el-table-column prop="amount" label="Amount" width="200">
                  <template slot-scope="x">                    
                      RM {{ x.row.amount | formatMoney }}                  
                  </template>
              </el-table-column>
              <el-table-column prop="paymentdate" label="Date" width="200">
                  <template slot-scope="x">                    
                      {{ x.row.paymentdate | tarikh }}                  
                  </template>
              </el-table-column>
              
          </el-table>
        </el-tab-pane>
      <el-tab-pane label="Database" :disabled="!isActive || moment().isAfter(expiry)">
        <dashboard-database v-if="isActive && moment().isBefore(expiry)"></dashboard-database>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DashboardDatabase from './DashboardDatabase.vue'
export default {
  components: { DashboardDatabase },
    name: 'Dashboard',
    data() {
        return {
            moment: moment,
            month: null,
            loading: false,
            clicks: {},
            commissions: []
        }
    },
    computed: {
        isLoggedIn: function () { return this.$store.getters.isLoggedIn },
        stateWebID: function () { return this.$store.getters.stateWebID },
        isActive:   function () { return this.$store.getters.isActive },
        expiry:     function () { return this.$store.getters.expiry }
    },
    methods: {
      getClicks () {
        this.loading = true
        axios('/clicks',  { params: {month: this.month }}).then( resp => {
          this.clicks = resp.data.clicks
          this.commissions = resp.data.clicks.commissions
          this.loading = false
        })
      },
      cliplink() {
        this.$refs.cliplink.focus();
        document.execCommand('copy')
        this.$refs.cliplink.blur();
        this.$message('Link affiliate telah disalin.');
      },
      tabDashboard(here) {
        console.log(here)
      }
    },
    created() {   
        this.loading = true
        this.month = moment().format('yyyy-MM-DD');
        this.getClicks();
    },
    filters: {
        bulan(x) {
            return moment(x,'yyyy-MM-DD hh:mm:ss').format('MMMM, yyyy')
        },
        tarikh(x) {
            return moment(x,'yyyy-MM-DD hh:mm:ss').format('DD/MM/yyyy')
        },
        formatMoney (v) {
            return v == null ? '0.00' : parseFloat(v).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');  // 12,345.67
        }
    }
}
</script>
